import { cva, type VariantProps } from 'class-variance-authority'

export { default as Switch } from './Switch.vue'
export { default as SwitchLabel } from './SwitchLabel.vue'

/**
 * ===========================================
 * Switch
 * ===========================================
 */
export const switchVariants = cva(
  'peer inline-flex shrink-0 cursor-pointer items-center transition-all rounded-full data-[state=checked]:bg-brand-blue1 data-[state=unchecked]:bg-text-hover data-[disabled]:cursor-not-allowed data-[disabled]:bg-text-glass-disabled!',
  {
    variants: {
      size: {
        sm: 'h-4 w-5.5',
        md: 'h-4.5 w-8',
        lg: 'h-5 w-10',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export const switchThumbVariants = cva(
  'pointer-events-none block rounded-full ring-0 transition-all data-[state=checked]:bg-white data-[state=unchecked]:bg-white data-[disabled]:bg-text-disabled!',
  {
    variants: {
      size: {
        sm: 'size-3 data-[state=unchecked]:translate-x-0.5 data-[state=checked]:translate-x-2',
        md: 'size-3.5 data-[state=unchecked]:translate-x-0.5 data-[state=checked]:translate-x-4',
        lg: 'size-4 data-[state=unchecked]:translate-x-0.5 data-[state=checked]:translate-x-5.5',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

/**
 * ===========================================
 * SwitchLabel
 * ===========================================
 */
export const switchWrapperVariants = cva(
  'inline-flex items-center rounded-full bg-key text-black-white transition-all px-1',
  {
    variants: {
      size: {
        sm: 'gap-1 px-1.5 py-1 text-s-medium',
        md: 'gap-1.5 p-1.5 text-s-medium',
        lg: 'gap-2 p-2 text-m-medium',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  },
)

export type SwitchVariants = VariantProps<typeof switchVariants>
